import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/assets/env/environment';
import { VersionService } from '../../api';

export interface VersionInfo {
  apiVersion: string;
  apiCommit: string;
  env: string;
  backofficeVersion: string;
  backofficeCommit: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  constructor(private versionApi: VersionService) { }

  getVersionInfo(): Observable<VersionInfo> {
    return this.versionApi.versionEndpoint().pipe(
      map(v => ({
        apiVersion: v.apiVersion,
        apiCommit: v.apiCommit ?? v.commit ?? '-',
        env: v.environment,
        backofficeVersion: environment.BACKOFFICE_VERSION,
        backofficeCommit: environment.BACKOFFICE_COMMIT_HASH
      }))
    );
  }
}
